import React from 'react';

import styled from 'styled-components';

import Select from 'components/lib/Select';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 185px;
`;

const Title = styled.div`
  color: var(--text-primary);
  font-size: 12px;
  margin-bottom: 5px;
`;

interface Props<T extends string | number> {
  title: string | React.ReactNode;
  value: T;
  options: any[];
  disabled?: boolean;
  onSelect: (value: T) => void;
}

const CommunityViewWidgetModalFilterSingleSelect = <T extends string | number>({
  title,
  value,
  options,
  disabled = false,
  onSelect,
}: Props<T>) => (
  <Container>
    <Title>{title}</Title>
    <Select
      style={{ height: 36 }}
      className={'rectangular'}
      value={value}
      options={options}
      disabled={disabled}
      onChange={onSelect}
    />
  </Container>
);

export default CommunityViewWidgetModalFilterSingleSelect;
